import { render, staticRenderFns } from "./dropmenu.vue?vue&type=template&id=27bea953&scoped=true&lang=html"
import script from "./dropmenu.vue?vue&type=script&lang=js"
export * from "./dropmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bea953",
  null
  
)

export default component.exports